import StringFilterModel from "@/components/Tables/Filters/models/stringFilterModel";
import DateFilterModel from "@/components/Tables/Filters/models/dateFilterModel";
import { humanizeDateTime } from "@/components/Tables/formatters";
import ValuePickerFilterModel from "@/components/Tables/Filters/models/valuePickerFilterModel";
import { InitialState } from "@/components/Tables/Filters/models/tableFilter";

export const isDeletedField = {
  key: "is_deleted",
  label: "Статус удаления",
  filter: new ValuePickerFilterModel(
    [
      { text: "Запись удалена", value: true },
      { text: "Запись не удалена", value: false }
    ],
    new InitialState([false], true)
  ),
  formatter: value => Boolean(Number(value)),
  display: false
};

export const defaultHistoryFields = [
  {
    key: "creator",
    label: "Автор изменений",
    filter: new StringFilterModel(),
    formatter: value => (value === null ? "Создано системой" : value.name)
  },
  {
    key: "creation_timestamp",
    label: "Дата и время изменений",
    filter: new DateFilterModel(),
    formatter: value => humanizeDateTime(value)
  },
  {
    key: "is_deleted",
    label: "Статус удаления",
    filter: new ValuePickerFilterModel(
      [
        {
          text: "Запись удалена",
          value: true
        },
        {
          text: "Запись не удалена",
          value: false
        }
      ],
      new InitialState([false])
    ),
    formatter: value => Boolean(Number(value)),
    display: false
  }
];

export const displayableFields = fields =>
  fields.filter(({ display }) => display !== false);
